import { useMediaQuery, useTheme } from '@material-ui/core'
import TextField from '@material-ui/core/TextField/TextField'
import Typography from '@material-ui/core/Typography/Typography'

import { useStyles } from './styles/RatePlansCodeMapingModalRow.styles'

interface RatePlansCodeMapingModalRowProps {
  AdotelName: string
  AdotelCode: string
  PMSCode: string
  disabled: boolean
  onChange: (event: string) => void
  customizedForChannel?: boolean
}
const RatePlansCodeMapingModalRow: React.FC<
  RatePlansCodeMapingModalRowProps
> = ({
  AdotelName,
  AdotelCode,
  PMSCode,
  disabled,
  onChange,
  customizedForChannel
}) => {
  const classes = useStyles()
  const theme = useTheme()

  return (
    <div className={[classes.mainDiv, disabled && classes.disabled].join(' ')}>
      <div>
        <Typography variant="body1">{AdotelName}</Typography>
      </div>
      {useMediaQuery(theme.breakpoints.up('sm')) && (
        <div>
          <Typography variant="body1">{AdotelCode}</Typography>
        </div>
      )}
      <div>
        <TextField
          value={PMSCode}
          variant="outlined"
          size="small"
          disabled={disabled}
          onChange={(event) => onChange(event.currentTarget.value)}
          error={
            (!customizedForChannel && PMSCode === '') ||
            (!customizedForChannel && PMSCode === null) ||
            PMSCode.toLocaleLowerCase() === 'nodata'
          }
        />
      </div>
    </div>
  )
}
export default RatePlansCodeMapingModalRow
